import {
    Component,
    EventEmitter,
    forwardRef,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewEncapsulation
} from '@angular/core';
import {AbstractControlComponent} from '../../../classes/abstract-control.component';
import {VssFormItemModel} from '../vss-control.model';
import {FormItemType} from '../vss-control.enum';
import {NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'vss-ui-form-item[field]',
    templateUrl: './form-item.component.html',
    styleUrls: ['./form-item.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => VssFormItemComponent),
            multi: true
        }
    ],
    encapsulation: ViewEncapsulation.None,
})
export class VssFormItemComponent extends AbstractControlComponent<any | any[]> implements OnInit {
    /***
     *
     * @param labelCol giá trị từ 1 - 24
     *
     ***/
    @Input() labelCol = 24;
    /***
     *
     * @param controlCol giá trị từ 1 - 24
     *
     ***/
    @Input() controlCol = 24;
    @Input() MAX_LENGTH_TEXT = 256;
    @Input() field: VssFormItemModel;
    @Input() refId?: any;
    @Input() addOnAfterIcon?: string | null;
    @Input() addOnBeforeIcon?: string | null;
    @Input() prefixIcon?: string | null;
    @Input() suffixIcon?: string | null;
    @Input() addOnAfter?: string | TemplateRef<void>;
    @Input() addOnBefore?: string | TemplateRef<void>;
    @Input() prefix?: string | TemplateRef<void>;
    @Input() suffix?: string | TemplateRef<void>;
    @Output() keyup: EventEmitter<any> = new EventEmitter<any>();
    @Output() keyupEnter: EventEmitter<any> = new EventEmitter<any>();
    formItemType = FormItemType;
    colDateTypes: FormItemType[] = [
        FormItemType.DATE_PICKER,
        FormItemType.DATE_PICKER,
        FormItemType.DATE_TIME_PICKER,
        FormItemType.DATE_TIME_RANGE_PICKER,
        FormItemType.DATE_RANGE_PICKER
    ];

    ngOnInit(): void {
    }

    emitEvent(e: EventEmitter<any>, v: any) {
        e.emit(v);
    }
}
